import { apiRegister } from '../utils/api'


// 1371	award2019/youpin	/award2020/dianjin/user/priv/	我的权限
export const djMyPrivList = apiRegister('djMyPrivList', {
  protoId: 1371,
  path: '/award2020/dianjin/user/priv/'
}).send
